// The ONE place the SPA hands the browser a file (a guard under `scripts/`
// allows `URL.createObjectURL` here only). Three hand-rolled copies preceded it,
// and one of them clicked a DETACHED anchor and revoked its URL in the same
// tick — both can silently drop the download.
//
// `a.click()` only SCHEDULES the download: the anchor must be in the document
// when clicked (Firefox ignores a detached one), and the URL must outlive the
// click, so the revoke and the removal land on a later tick.
//
// Throws what the browser throws (e.g. no blob URLs); a caller that must SAY a
// download did not start catches it.

/** The browser surfaces touched — injected by tests, the real globals otherwise. */
export type DownloadEnv = {
  readonly document: Pick<Document, 'createElement' | 'body'>;
  readonly URL: Pick<typeof URL, 'createObjectURL' | 'revokeObjectURL'>;
  readonly setTimeout: (fn: () => void, ms: number) => unknown;
};

export function downloadBlob(
  filename: string,
  blob: Blob,
  env: DownloadEnv = { document, URL, setTimeout },
): void {
  const url = env.URL.createObjectURL(blob);
  const a = env.document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  env.document.body.appendChild(a);
  a.click();
  env.setTimeout(() => {
    env.URL.revokeObjectURL(url);
    a.remove();
  }, 0);
}
